import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Input } from "@faire/web/slate/Input";
import { Dropdown } from "@faire/web/slate/Input/Dropdown";
import { TextArea } from "@faire/web/slate/Input/TextArea";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { DropdownGroups } from "../components/DropdownGroups";
import { validateEmail } from "../consts";
import { useLoggedOutContactUsContextStore } from "../hooks/LoggedOutContactUsContextStore";
import { useLoggedOutEmailContextStore } from "../hooks/LoggedOutEmailContextStore";
import { useLoggedOutIssuesDropdown } from "../hooks/useLoggedOutIssuesDropdown";
import { useLoggedOutUserType } from "../hooks/useLoggedOutUserType";
import { BUSINESS_NAME_PROMPT_MESSAGE, CUSTOMER_TYPE_PROMPT_MESSAGE, EMAIL_PROMPT_MESSAGE, getCustomerTypeList, TICKET_DETAIL_PROMPT_MESSAGE } from "../shared-text";
export var LoggedOutContactUsView = function LoggedOutContactUsView() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var customerListType = getCustomerTypeList(strictLocalize);
  var _useLoggedOutContactU = useLoggedOutContactUsContextStore(["user"]),
    _useLoggedOutContactU2 = _slicedToArray(_useLoggedOutContactU, 1),
    user = _useLoggedOutContactU2[0].user;
  var _useLoggedOutUserType = useLoggedOutUserType(),
    isKnownUserType = _useLoggedOutUserType.isKnownUserType;
  var _useLoggedOutIssuesDr = useLoggedOutIssuesDropdown(),
    handleUserDropdown = _useLoggedOutIssuesDr.handleUserDropdown;
  var _useLoggedOutEmailCon = useLoggedOutEmailContextStore(["businessName", "contactEmail", "details", "emailErrorMessage", "descriptionErrorMessage", "businessNameErrorMessage", "formErrorMessage"]),
    _useLoggedOutEmailCon2 = _slicedToArray(_useLoggedOutEmailCon, 2),
    _useLoggedOutEmailCon3 = _useLoggedOutEmailCon2[0],
    businessName = _useLoggedOutEmailCon3.businessName,
    contactEmail = _useLoggedOutEmailCon3.contactEmail,
    details = _useLoggedOutEmailCon3.details,
    emailErrorMessage = _useLoggedOutEmailCon3.emailErrorMessage,
    descriptionErrorMessage = _useLoggedOutEmailCon3.descriptionErrorMessage,
    businessNameErrorMessage = _useLoggedOutEmailCon3.businessNameErrorMessage,
    setLoggedOutEmailContextStore = _useLoggedOutEmailCon2[1];
  var handleTextArea = function handleTextArea(e) {
    setLoggedOutEmailContextStore({
      details: e.target.value
    });
  };
  var handleBusinessName = function handleBusinessName(e) {
    setLoggedOutEmailContextStore({
      businessName: e.target.value
    });
  };
  var handleContactEmail = function handleContactEmail(e) {
    setLoggedOutEmailContextStore({
      contactEmail: e.target.value
    });
  };
  var handleTextAreaBlur = function handleTextAreaBlur(e, strictLocalize) {
    if (e.target.value) {
      setLoggedOutEmailContextStore({
        descriptionErrorMessage: undefined
      });
    } else {
      setLoggedOutEmailContextStore({
        descriptionErrorMessage: strictLocalize({
          id: "Ay3aoN",
          defaultMessage: [{
            "type": 0,
            "value": "Please enter a description"
          }]
        })
      });
    }
  };
  var handleBusinessNameBlur = function handleBusinessNameBlur(e, strictLocalize) {
    if (e.target.value) {
      setLoggedOutEmailContextStore({
        businessNameErrorMessage: undefined
      });
    } else {
      setLoggedOutEmailContextStore({
        businessNameErrorMessage: strictLocalize({
          id: "iwbE4y",
          defaultMessage: [{
            "type": 0,
            "value": "Please enter a business name"
          }]
        })
      });
    }
  };
  var handleContactEmailBlur = function handleContactEmailBlur(e, strictLocalize) {
    var isValid = validateEmail(e.target.value);
    if (isValid) {
      setLoggedOutEmailContextStore({
        emailErrorMessage: undefined
      });
    } else {
      setLoggedOutEmailContextStore({
        emailErrorMessage: strictLocalize({
          id: "prBAWB",
          defaultMessage: [{
            "type": 0,
            "value": "Please enter a valid email"
          }]
        })
      });
    }
  };
  return /*#__PURE__*/React.createElement(Column, {
    "data-test-id": "logged-out-contact-us-view"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "pageHeaderSerifRegular"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "mhvr/V",
    defaultMessage: [{
      "type": 0,
      "value": "Contact us"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "3x"
  }), /*#__PURE__*/React.createElement(Dropdown, {
    value: user,
    placeholder: CUSTOMER_TYPE_PROMPT_MESSAGE(strictLocalize),
    options: customerListType,
    onSelect: handleUserDropdown
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), isKnownUserType ? ( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownGroups, null), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }))) : null, /*#__PURE__*/React.createElement(Input, {
    "aria-label": "Email",
    value: contactEmail,
    placeholder: EMAIL_PROMPT_MESSAGE(strictLocalize),
    onChange: handleContactEmail,
    onBlur: function onBlur(e) {
      return handleContactEmailBlur(e, strictLocalize);
    },
    error: emailErrorMessage
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(Input, {
    "aria-label": "Business Name",
    value: businessName,
    placeholder: BUSINESS_NAME_PROMPT_MESSAGE(strictLocalize),
    onChange: handleBusinessName,
    onBlur: function onBlur(e) {
      return handleBusinessNameBlur(e, strictLocalize);
    },
    error: businessNameErrorMessage
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }), /*#__PURE__*/React.createElement(TextArea, {
    "aria-label": "Description",
    label: strictLocalize({
      id: "JsXM9x",
      defaultMessage: [{
        "type": 0,
        "value": "Description"
      }]
    }),
    placeholder: TICKET_DETAIL_PROMPT_MESSAGE(strictLocalize),
    style: {
      minHeight: "120px"
    },
    value: details,
    onChange: handleTextArea,
    onBlur: function onBlur(e) {
      return handleTextAreaBlur(e, strictLocalize);
    },
    error: descriptionErrorMessage
  }), /*#__PURE__*/React.createElement(Spacer, {
    height: "2x"
  }));
};